import omit from 'lodash-es/omit';
import { httpService } from '../..';
import { IApiExecuteRespone } from '../apiInterfaces';
import { ApiUrls } from '../ApiUrls';
import { executeApiRequest } from '../asyncUtils';
import { IProduct } from '../products';
import {
  ITargetedCatalogApiResponse,
  ITargetedCatalogGroup,
  ITargetedCatalogItem,
  ITargetedCatalogSectionBase
} from './targetedCatalogInterfaces';

export async function fetchTargetedCatalog(request: {
  brand?: string;
  full?: boolean;
}): Promise<IApiExecuteRespone<ITargetedCatalogApiResponse>> {
  return executeApiRequest(() => httpService.get(ApiUrls.targetedCatalog(request)));
}

export async function updateTargetedItemGroup(request: Omit<ITargetedCatalogGroup, 'products'>, order?: boolean) {
  const group = omit(request, ['products', 'productIds']);
  return executeApiRequest(() => httpService.post(ApiUrls.targetedCatalogItemGroup({ order }), group));
}

export async function deleteItem(catalogItemId: number) {
  return executeApiRequest(() => httpService.delete(ApiUrls.targetedCatalogItem(catalogItemId)));
}

export async function deleteGroup(groupId: number) {
  return executeApiRequest<ITargetedCatalogGroup[]>(() =>
    httpService.delete(ApiUrls.targetedCatalogItemGroup({ groupId }))
  );
}

export async function deleteSection(sectionId: number) {
  return executeApiRequest(() => httpService.delete(ApiUrls.targetedCatalogSection(sectionId)));
}

export async function updateSection(section: ITargetedCatalogSectionBase) {
  return executeApiRequest(() => httpService.post(ApiUrls.targetedCatalogSection(), section));
}

export async function itemSearch({ searchTerm, sectionId }: { sectionId: number; searchTerm: string }) {
  return executeApiRequest<IProduct[]>(() => httpService.get(ApiUrls.targetedCatalogItemSearch(sectionId, searchTerm)));
}

export async function addItems(value: { preseasonCatalogItemGroupId: number; itemIds: string[] }) {
  const url = `${ApiUrls.targetedCatalogItemGroup({ groupId: value.preseasonCatalogItemGroupId })}/AddItems`;
  return executeApiRequest<ITargetedCatalogItem[]>(() => httpService.post(url, value.itemIds));
}

export async function updateItem(value: ITargetedCatalogItem) {
  return executeApiRequest<ITargetedCatalogItem[]>(() => httpService.post(ApiUrls.targetedCatalogItem(), value));
}
